import config from '@/assets/js/config'
import axios from '@/assets/libs/ajax'
import qs from 'qs';

// let baseUrl = process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config.baseUrl.pro;
let share = config.baseUrl.pro

//生成支付链接
let token01 = null;
export const Payment = async (data) => {
    if (token01) {
        token01.cancel({
            status: 'cancel'
        });
    }
    token01 = axios.token();
    return axios.ajax({
        url: share.wb[4] + "?" + qs.stringify(data),
        method: "get",
        token: token01.token,
    })
};